export default {
    props: {
        plotAreaBackground: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.background'
        }, 
        plotAreaBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.border.color'
        }, 
        plotAreaBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.border.dashType'
        }, 
        plotAreaBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.border.width'
        }, 
        plotAreaMargin: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.margin'
        }, 
        plotAreaMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.margin.bottom'
        }, 
        plotAreaMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.margin.left'
        }, 
        plotAreaMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.margin.right'
        }, 
        plotAreaMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.margin.top'
        }, 
        plotAreaOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.opacity'
        }, 
        plotAreaPadding: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.padding'
        }, 
        plotAreaPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.padding.bottom'
        }, 
        plotAreaPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.padding.left'
        }, 
        plotAreaPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.padding.right'
        }, 
        plotAreaPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.padding.top'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/PlotArea.js